import config from '../../../../config/notificateur.json' with { type: 'json' };
function entierPositif(nom, valeur) {
    if (typeof valeur !== 'number' || !Number.isInteger(valeur) || valeur < 0) {
        throw new Error(`config/notificateur.json : ${nom} doit être un entier positif`);
    }
    return valeur;
}
/**
 * Validé au chargement : un seuil mal saisi doit casser au déploiement, pas
 * produire des lots de 1000 objets que le destinataire refuse en 413.
 */
export const PARAMETRES_NOTIFICATEUR = {
    objetsParLot: (() => {
        const n = entierPositif('objets_par_lot', config.objets_par_lot);
        // Plafond convenu avec NUXI : au-delà, 413. Refuser ici plutôt qu'écrêter
        // en silence — un réglage qui ne s'applique pas est pire qu'une erreur.
        if (n < 1 || n > 100)
            throw new Error('config/notificateur.json : objets_par_lot entre 1 et 100');
        return n;
    })(),
    lotsParPassage: entierPositif('lots_par_passage', config.lots_par_passage),
    delaiAttenteMs: entierPositif('delai_attente_ms', config.delai_attente_ms),
    reessaisMs: config.reessais_ms.map((v, i) => entierPositif(`reessais_ms[${String(i)}]`, v)),
    reculMaxMin: entierPositif('recul_max_min', config.recul_max_min),
    reculRefusMin: entierPositif('recul_refus_min', config.recul_refus_min),
    fenetreEscalesJours: {
        avant: entierPositif('fenetre_escales_jours.avant', config.fenetre_escales_jours.avant),
        apres: entierPositif('fenetre_escales_jours.apres', config.fenetre_escales_jours.apres),
    },
};
//# sourceMappingURL=parametres.js.map